
import React from "react";
import { connect } from "react-redux";

@connect( store => {
    return {
        conversations: store.conversations,
        loggedUser: store.loggedUser
    }
})

class Workstreams extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { dispatch, conversations, isAdminNotMember, isAdmin, loggedUser} = this.props;
        const selected = conversations.selected;

        if( conversations.selected.id ) {
            const isMember = conversations.selected.tagged_users.filter(t=>t.linkId === loggedUser.data.id);
            const onRemoved = ( selected ) => {
                dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_ONLY", selected: { ...conversations.selected, tagged_workstreams_notes: conversations.selected.tagged_workstreams_notes.map( w => {
                    if( selected.workstream.id === w.workstream.id ) {
                        return {
                            ...w,
                            isRemoved: true
                        }
                    }

                    return w;
                }) }})
            }

            return (
                <div class="taggedFileWorkstreamList">
                    { conversations.selected.tagged_workstreams_notes.map( w => (
                        <div class={`taggedFileItem ${ w.isRemoved ? "removed" : "" }`}>
                            <div class="taggedFileDetails">
                                <div class="workstreamStatusIndicator" style={{ background: w.workstream.color }}></div>
                                <div class="taggedFileContent">
                                    <p>{ w.workstream.workstream }</p>
                                </div>
                            </div>
                            {isAdmin && !isAdminNotMember && !selected.isArchived && isMember.length > 0 &&
                                <div class="memberActions">
                                    { w.isRemoved && <button type="button" class="btn btnRemove disabled">Removed</button> }
                                    { !w.isRemoved && <button type="button" class="btn btnRemove" onClick={ () => onRemoved(w) }>Remove</button>}
                                </div>
                            }
                        </div>
                    ) )}

                    {conversations.selected.tagged_workstreams_notes.length === 0 && <div class="">No tagged Workstreams found</div>}
                </div>
            );
        }
    }
}

export default Workstreams;